(function (angular) {
	'use strict';

	angular.module('marketingModule', [
		'affixModule',
		'collapseModule',
		'coreModule',
		'duScroll',
		'fiveYearReturnsChartModule',
		'fundriseInvestorsEarnMoreChartModule',
		'goalTeaserModule',
		'historicalPerformanceChartModule',
		'localRealEstateModule',
		'metroMarketMapModule',
		'planModule',
		'portfolioAllocationChartModule',
		'realEstateVsInflationChartModule',
		'reAverageDividendYieldChartModule',
		'revealModule',
		'scrollDownPromptModule',
		'serviceLevelCardModule',
		'totalOriginationsChartModule',
		'viewPlanModule',
		'yieldComparisonChartModule'
	]);
})(window.angular);